<template>
  <div class="esf-main-container">
    <div style="background-color: white; border-radius: 8px; border: 1px solid #dee2e6; padding: 10px;">
      <b-row>
        <b-col lg="2" class="d-flex flex-column button-column">
          <button
            size="sm"
            :disabled="disableSaveButton"
            :class="[ 'process-btn-container', disableSaveButton ? 'disabled-btn' : 'fill-color-btn-color']"
            @click="CheckboxSave"
          >
            <span v-html="svg.SaveIcon" aria-label="Save"></span>
            Save
          </button>

          <button
            size="sm"
            class="process-btn-container outline-btn-color"
            @click="clearEditedAttachedPages(); CheckboxClear(); anyCheckboxSelected = false"
          >
            <span v-html="svg.ResetUndoIcon" aria-label="Reset"></span>
            Reset
          </button>

          <button
            size="sm"
            class="process-btn-container outline-btn-color"
            @click="showRejectFormModal"
          >
            <span v-html="svg.RejectCloseIcon" aria-label="Reject"></span>
            Reject
          </button>

          <button
            size="sm"
            :class="['process-btn-container', (processButtonDisabled || Object.keys(selectedTitleDocs).length<=0) ? 'light-blue-btn' : 'fill-color-btn-color']"
            :disabled="processButtonDisabled || Object.keys(selectedTitleDocs).length<=0"
            @click="doProcess"
          >
            <i v-if="processButtonDisabled" class="fa fa-spin fa-spinner" style="margin-right: 5px;"></i>
            <span v-else v-html="svg.ProcessPlayIcon" aria-label="Export"></span>
            {{ processButtonDisabled ? 'Processing...' : 'Export' }}
          </button>
        </b-col>

        <b-col lg="10" class="table-column">
          <b-card class="table-con">
            <div v-if="isRotatedDoc" class="notes-margin">
              <ul>
                <h5 style="font-weight: bold;">Note:</h5>
                <li>Kindly choose an image and adjust its orientation as needed.</li>
                <li>After rotating the pages, hit Export to see the whole document with the changes in Salesforce.</li>
              </ul>
            </div>
            <div v-else>
              <b-col lg="12">
                <table class="result">
                  <thead class="esf-table-header-con">
                    <tr>
                      <th v-if="!isRotatedDoc" class="table-padding table-left-align"> File Type </th>
                      <th class="table-padding table-center-align"> Page Numbers </th>
                      <th class="table-padding table-center-align"> Action </th> </tr>
                  </thead>
                  <tbody>
                    <tr :class="getResultCss(value)" v-for="(value,key) in selectedTitleDocs" :key="key" style="font-size: 12px; line-height: 1.2;">
                      <td v-if="!isRotatedDoc" class="black-border-btm table-left-align table-padding">{{value.template_doc.text}}</td>
                      <td class="table-padding" style="text-align: center; border-bottom: 1px solid #dee2e6;">{{value.pages.join(', ')}}</td>
                      <td class="table-padding" style="text-align: center; border-bottom: 1px solid #dee2e6;">
                        <b-button @click="editPages(value, key)" style="border-radius: 5px; padding: 0px 6px 0px 6px" variant="white" v-b-tooltip.hover.viewport title="Edit">
                          <span v-html="svg.EditPencilIcon"></span>
                        </b-button>
                        <b-button @click="removePages(value, key); anyCheckboxSelected = false" style="border-radius: 5px; padding: 0px 6px 0px 6px" variant="white" v-b-tooltip.hover.viewport title="Remove">
                          <span v-html="svg.DeleteTrashIcon"></span>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div style="background-color: white; border-radius: 8px; border: 1px solid #dee2e6; margin-top: 12px;">
      <b-row class="align-items-center">
        <b-col lg="12">
          <div class="d-flex justify-content-start align-items-center flex-wrap">
            <div class="ml-2 mr-3">
              <div class="select-input-container">
                <b-form-select
                  :plain="true"
                  :options="setFormTypeOptions"
                  :disabled="isRotatedDoc"
                  placeholder="Select File Type"
                  v-model="formType"
                  @change="disableCheckboxOnEditedDoc"
                  id="documentTypeSelect" class="custom-b-form-select"
                ></b-form-select>
                <label for="documentTypeSelect">File Type</label>
              </div>
            </div>

            <span
              class="mr-3 d-flex align-items-center"
              @click="toggleAllThumbnails"
              v-b-tooltip.hover.viewport
              title="Select All Thumbnails"
              style="cursor: pointer;"
            >
              <span
                v-if="selectAllThumbnails"
                class="fa fa-check-circle"
                aria-hidden="true"
                :style="{ 'font-size': '1.5em', 'color': '#015BAC', 'margin-right': '5px','padding-left':'10px'}"
              ></span>
              <span
                v-else
                v-html="svg['CircleOutlineIcon']"
                :style="{ 'font-size': '1.5em', 'color': 'gray', 'margin-right': '5px','padding-left':'10px'}"
              ></span>
              <span class="mt-2" style="font-weight: bold;">Select All</span>
            </span>
            <b-button
              size="sm"
              style= "border-radius: 6px; height: 30px; color:black; background-color: white; border: none; margin-right: 5px; display: flex; align-items: center; justify-content: center; outline: none !important; box-shadow: none !important;"
              @click="rotateSelectedImgs(-90)"
              class="mt-2"
            >
              <span v-html="svg['RotateLeftIcon']" style="padding: 2px;"></span>
            </b-button>
            <b-button
              size="sm"
              style="border-radius: 6px; height: 30px; color:black; background-color: white; border: none; display: flex; align-items: center; justify-content: center; outline: none !important; box-shadow: none !important;"
              @click="rotateSelectedImgs(+90)"
              class="mt-2"
            >
              <span v-html="svg['RotateRightIcon']" style="padding: 2px;"></span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <hr style="border-top: 2px solid #eee; margin-top: 20px; margin-bottom: 20px;">
     <b-row>
      <b-col lg="12" class="scrollable-content">
        <b-card class="mb-3" style="border-radius: 8px; border: none;">
          <div style="background-color: white; padding: 10px; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; overflow-x: auto;">
            <Container
              orientation="horizontal" @drop="(e) => onCardDrop('Templates', e)"
              @drag-start="(e) => log('drag start', e)"
              @drag-end="(e) => log('drag end', e)"
              :get-child-payload="getCardPayload('Templates')"
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :drop-placeholder="dropPlaceholderOptions"
              style="display: flex; flex-wrap: nowrap; min-width:500rem;"> <template v-if="scene.children[0] && scene.children[0].name === 'Templates'">
                <Draggable style="padding:1px; width:25rem;" v-for="card in scene.children[0].children" :key="card.id">
                  <div v-if="isEditedDoc ? (card.data.form && card.data.form.isEdited === true) :(card.data.form && card.data.form.process!== true)">
                    <div v-if="card.data.found && card.data.form" :class="card.props.className" v-bind:style="card.data.form.process == true ? 'border: 2px solid green' : 'border: none;'">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="checkbox-padding">
                          <input type="checkbox" class="thumbnail-checkbox" v-if="!card.data.form.isEdited" :id="card.id" ref="CheckboxClicks" v-on:change="updateDisableCheckBox()" />
                          <input type="checkbox" class="thumbnail-checkbox" v-else :value="card.data.form.id" :id="card.id" ref="CheckboxClicks" v-on:change="updateDisableCheckBox()" v-model="editedCheckedBoxes" />
                        </div>
                        <p style="margin: 8px;">Page: {{card.data.form.original_page_no}}</p>
                      </div>
                      <img @load = "loadingImage($event, card.data.form)" onContextMenu="return false;" v-on:click="viewFullImage(card.data.form, 'singleColumnName')" width="200" height="380" :src="card.data.form ? axios.defaults.baseURL.replace('/api', '') + card.data.form.image_thumbnail: ''" class="card-img" :id="card.data.form.id + card.data.form.original_title" :style="{ transform: `rotate(${card.data.form.rotation}deg)` }">
                    </div>
                    <div v-else>
                      <img onContextMenu="return false;" width="200" height="239" class="card-img">
                    </div>
                  </div>
                  <div v-else>
                    <img onContextMenu="return false;" width="200" height="239" class="card-img">
                  </div>
                </Draggable>
              </template>
            </Container>
          </div>
        </b-card>
      </b-col>
     </b-row>
    </div>


    <b-modal class="modal-primary" size="lg" centered id = "hideModal" ref="viewFullImage" no-close-on-esc hide-header-close no-close-on-backdrop scrollable >
      <div slot="modal-header">
        <label >{{ selectedImage.title }}</label>
        <b-button size="sm" variant="dark" style="padding: 4px 8px;border-radius:0px" @click="imageRotateLeft()" v-b-tooltip.hover.viewport :title="$t('FORMS.ROTATE_LEFT')"><i class="fa fa-undo"></i></b-button>
        <b-button size="sm" variant="dark" style="padding: 4px 8px;border-radius:0px" @click="imageRotateRight()" v-b-tooltip.hover.viewport :title="$t('FORMS.ROTATE_RIGHT')"><i class="fa fa-repeat"></i></b-button>
      </div>
      <b-row>
        <b-col :sm="12">
          <div style="height: 75vh; overflow-y:auto">
            <img style = "width: 80%" onContextMenu="return false;" @load = "loadingImage($event,selectedImage)" v-if="modelOpen" :src="selectedImage ? axios.defaults.baseURL.replace('/api', '') + selectedImage.image_url: ''" class="card-img" :id="selectedImage.id" :style="{ transform: `rotate(${this.angle}deg)` }">
          </div>
        </b-col>
      </b-row>
      <div slot="modal-footer">
          <b-btn size="sm" variant="secondary" @click="saveRotationTemplateImage()"> Save </b-btn>
          <b-btn size="sm" variant="light" @click="closeRotationTemplateImage()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>

    <b-modal hide-header-close title="Reject Form" header-bg-variant="light" ref="rejectFormDoc" centered>
      <div v-html="svg.rejectExclamation" class="reject-bg-con-color warning-con mb-2"></div>
      <h5>Do you want to reject this document?</h5>
      <div slot="modal-footer">
        <b-btn size="sm" class="custom-btn" @click="hideRejectFormDocModal">Cancel</b-btn>
        <b-btn size="sm" class="custom-btn" @click="rejectForm">Confirm</b-btn>
      </div>
    </b-modal>
    <b-modal hide-header-close title="Alert" header-bg-variant="light" ref="rotatePagesAlert" centered>
      <div v-html="svg.warningAlert" class="warning-con warning-bg-con-color mb-2"></div>
      <h5>Kindly Select atleast one form to rotate</h5>
      <div slot="modal-footer">
        <b-btn size="sm" class="custom-btn" @click="$refs.rotatePagesAlert.hide()">Okay</b-btn>
      </div>
    </b-modal>
    <b-modal hide-header-close title="Alert" header-bg-variant="light" ref="splitDocAlert" centered>
      <div v-html="svg.warningAlert" class="warning-con warning-bg-con-color mb-2"></div>
      <h5>Please complete the form split before exporting</h5>
      <div slot="modal-footer">
        <b-btn size="sm" class="custom-btn" @click="$refs.splitDocAlert.hide()">Okay</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import { generateItems } from './helpers'
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import { uuid } from 'vue-uuid'
import svg from '../../_svg.js'
import Triaging from '../../components/mixins/Triaging.js'

const columnNames = ['Templates']
const cardColors = [
  'azure',
  'beige',
  'bisque',
  'blanchedalmond',
  'burlywood',
  'cornsilk',
  'gainsboro',
  'ghostwhite',
  'ivory',
  'khaki'
]
const pickColor = () => {
  const rand = Math.floor(Math.random() * 10)
  return cardColors[rand]
}
const scene = {
  type: 'container',
  props: {
    orientation: 'horizontal'
  },
  children: generateItems(columnNames.length, i => ({
    id: `column${i}`,
    type: 'container',
    name: columnNames[i],
    props: {
      orientation: 'vertical',
      className: 'card-container'
    },
    children: generateItems(2, j => ({
      type: 'draggable',
      id: `${i}${j}`,
      props: {
        className: 'card',
        style: {backgroundColor: pickColor()}
      },
      data: 'yes'
    }))
  }))
}

export default {
  mixins: [Triaging],
  name: 'Cards',
  components: {Container, Draggable, Multiselect, uuid},
  data () {
    return {
      loading: false,
      scene,
      showTooltip: false,
      svg: svg,
      upperDropPlaceholderOptions: {
        className: 'cards-drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      dropPlaceholderOptions: {
        className: 'drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      matchedPages: [],
      nonMatchedPages: [],
      dLCards: [],
      icCards: [],
      allPages: [],
      angle: 0,
      rotateAllAngle: 0,
      modelOpen: false,
      rotationSave: false,
      selectedImage: {},
      selectedColumn: '',
      templateOptions: [],
      formType: null,
      selectedTitleDocs: {},
      isFirstEditButtonClicked: false,
      previewImageUrl: '',
      forced_template_doc_id: '',
      processButtonDisabled: false,
      CheckboxClicks: '',
      text: '',
      vaildFormsData: false,
      traigeStatus: {
        NEW: 1,
        INPROGRESS: 2,
        PARTIALLY_COMPLETED: 3,
        COMPLETED: 4,
        REJECTED: 5,
        RECALLED: 6,
        TRIAGED: 12
      },
      selectedProduct: [],
      groupDocs: {
      },
      inBoundDocumentCaseId: '',
      showResult: true,
      editAttachmentsEnabled: null,
      editInsCardsEnabled: null,
      isEditedDocKey: null,
      isEditedDoc: false,
      disableSaveButton: true,
      columnCount: 1,
      editedCheckedBoxes: [],
      formDocTitle: '',
      isRotatedDoc: false,
      formDoc: null,
      rotationAngle: 0,
      selectAllThumbnails: false,
      documentPreviewChecked: false,
      anyCheckboxSelected: false
    }
  },
  beforeDestroy () {
    this.scene.children.map(column => {
      if (column.type === 'container') {
        column.children.map(element => {
          if (element.data.form) {
            element.data.form.process = true
            element.data.form.isAttachment = true
          }
          if (element.data.form) {
            element.data.form.process = true
            element.data.form.isInsurance = true
          }
        })
      }
    })
    this.editAttachmentsEnabled = null
    this.editInsCardsEnabled = null
  },
  created () {
    this.$refs.CheckboxClicks = []
    Vue.axios.get('/form_docs/' + this.$route.params.id, { headers: { Authorization: `Bearer ${this.idToken}` } })
      .then(res => {
        this.isRotatedDoc = res.data.form_doc.is_rotated
        this.formDoc = res.data.form_doc
        if (res.data.form_doc.forms_doc_status === 1) {
          this.setDocumentStatus(this.traigeStatus['INPROGRESS'])
        }
        this.inBoundDocumentCaseId = res.data.form_doc.inbound_doc_case_id
        let pages = res.data.forms.map(eachFormData => {
          let newForm = eachFormData.form
          newForm.image_thumbnail = eachFormData.image_thumbnail
          newForm.image_url = eachFormData.image_path
          newForm.original_title = eachFormData.form.title
          newForm.angle = eachFormData.form.rotation_angle
          newForm.process = false
          newForm.isAttachment = false
          newForm.isInsurance = false
          newForm.rotation = eachFormData.form.rotation_angle
          return newForm
        })
        let keys = Object.keys(res.data.form_doc.saved_triage_docs)
        this.selectedTitleDocs = res.data.form_doc.saved_triage_docs
        let sceneColumns = {}
        for (const key of keys) {
          let value = this.selectedTitleDocs[key]
          if (sceneColumns[value.sceneColumn] === undefined) {
            sceneColumns[value.sceneColumn] = []
          }
        }
        this.productList = res.data.product_list
        this.formDocTitle = res.data.form_doc.title
        this.allPages = pages
        this.matchedPages = pages
        this.nonMatchedPages = []
        this.dLCards = []
        this.icCards = []

        let newScean = {
          type: 'container',
          props: {
            orientation: 'horizontal'
          },
          children: generateItems(columnNames.length, j => {
            return ({
              id: `Templates`,
              type: 'container',
              name: columnNames[0],
              props: {
                orientation: 'vertical',
                className: 'card-container'
              },
              children: this.allPages.map((form, index) => ({
                type: 'draggable',
                id: `${index}`,
                props: {
                  className: 'card',
                  style: {backgroundColor: pickColor()}
                },
                data: {name: 'template', found: true, form: form}
              }))
            })
          })
        }
        this.scene = newScean
        this.setSavedTriageDocs()
        this.validAllForms()
        this.sortDraggablesForms()
        Vue.axios.get('/template_docs/list_esf_options', {
          headers: { Authorization: `Bearer ${this.idToken}` },
          params: {process_category: 'ESF'}
        })
          .then(response => {
            this.templateOptions = response.data.template_docs
            console.log('templateOptionssss', this.templateOptions)
          }, error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else if (error.status === 500) {
              Vue.toasted.show(this.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' })
            }
          })
      })
      .catch(err => console.log(err))
  },
  methods: {
    toggleDocumentPreview () {
      this.documentPreviewChecked = !this.documentPreviewChecked
    },
    toggleAllThumbnails () {
      this.selectAllThumbnails = !this.selectAllThumbnails
      Vue.nextTick(() => {
        if (this.selectAllThumbnails) {
          this.$refs.CheckboxClicks.forEach(checkbox => {
            checkbox.checked = true
          })
        } else {
          this.$refs.CheckboxClicks.forEach(checkbox => {
            checkbox.checked = false
          })
        }
        this.updateDisableCheckBox()
      })
    },
    setSavedTriageDocs () {
      let keys = Object.keys(this.selectedTitleDocs)
      this.columnCount = keys.length === 0 ? 1 : Number(keys[keys.length - 1]) + 1
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            for (const key of keys) {
              if (element.data.form && this.selectedTitleDocs[key].formIDs.includes(element.data.form.id)) {
                element.data.form.process = true
                element.data.form.title = this.selectedTitleDocs[key].title
                this.selectedTitleDocs[key].forms.map(form => {
                  if (element.data.form.id === form.id) {
                    element.data.form.product = form.product
                    element.data.form.tags = form.tags
                    element.data.form.template_doc_id = form.template_doc_id
                    element.data.form.closest_template_id = form.closest_template_id
                  }
                })
                element.data.form.uuid = this.selectedTitleDocs[key].uuid
              }
            }
          })
        }
      })
    },
    sortDraggablesForms () {
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.sort((a, b) => {
            if (a.data.form && b.data.form) {
              if (a.data.form.process === false && b.data.form.process === true) {
                return -1
              }
              if (a.data.form.process === true && b.data.form.process === false) {
                return 1
              }
              return a.data.form.original_page_no - b.data.form.original_page_no
            }
            return 0
          })
        }
      })
    },
    CheckboxSave: function () {
      this.isSaveButtonClicked = true
      this.isFirstEditButtonClicked = false
      let checkedIdArray = []
      let uncheckedIdArray = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        } else {
          uncheckedIdArray.push(element.id)
        }
      })
      if (checkedIdArray.length > 0) {
        if (this.formType) {
          let documentType = this.templateOptions.find(templateDoc => templateDoc.value === this.formType)
          if (
            documentType &&
            documentType.templates.length !== 0 &&
            documentType.templates.length !== checkedIdArray.length
          ) {
            this.isFirstEditButtonClicked = true
            return Vue.toasted.show('The selected document type has more or fewer pages than the selected forms.', {type: 'error', duration: 5000})
          }
        } else if (!this.isRotatedDoc && this.formType === null) {
          return Vue.toasted.show('File Type is required', {type: 'error'})
        }
        let title = this.text.trim().replace(/ /g, '_')
        let isValidTemplates = true
        let docDetails = {}
        let uniqueId = uuid.v1()
        docDetails['title'] = title
        docDetails['forms'] = []
        docDetails['pages'] = []
        docDetails['formIDs'] = []
        docDetails['template_doc'] = []
        docDetails['force_template_id'] = []
        docDetails['sceneColumn'] = []
        docDetails['tags'] = []
        console.log('docDetails = ', docDetails)
        this.scene.children.map(column => {
          if (column.type === 'container') {
            this.extractFormTypeData(column.name, column.children)
            column.children.map(element => {
              if (checkedIdArray.indexOf(element.id) >= 0) {
                if (this.formType) {
                  docDetails['forms'].push(element.data.form)
                  docDetails['formIDs'].push(element.data.form.id)
                  docDetails['formType'] = this.formType
                  docDetails['column'] = {text: column.name, value: column.name === 'Insurance cards' ? '-2' : '0'} // Check this logic if 'Insurance cards' is no longer a separate column
                  docDetails['pages'].push(element.data.form.original_page_no)
                  docDetails['force_template_id'] = this.formType
                  docDetails['sceneColumn'] = column.id
                  docDetails['template_doc'] = this.templateOptions.filter(template => {
                    return template.value === this.formType
                  })
                  if (!this.isEditedDoc) {
                    docDetails['uuid'] = uniqueId
                  }
                  if (column.name === 'Templates' && docDetails['template_doc'].length < 1 && this.formType !== 'attachments') {
                    isValidTemplates = false
                  } else {
                    element.data.form.title = title
                    element.data.form.process = true
                    element.data.form.isEdited = false
                    element.data.form.template_doc_id = this.formType
                    element.data.form.uuid = uniqueId
                  }
                }
              }
              if (uncheckedIdArray.indexOf(element.id) >= 0) {
                element.data.form.process = false
                element.data.form.isEdited = false
              }
            })
          }
        })
        if (isValidTemplates) {
          if (this.isEditedDoc) {
            let attachementsFormIds = this.selectedTitleDocs[this.isEditedDocKey]['attachment_formIds'] || []
            let originalUuid = this.selectedTitleDocs[this.isEditedDocKey]['uuid']

            if (attachementsFormIds.length > 0) {
              docDetails['formIDs'].push(...attachementsFormIds)
            }
            docDetails['attachment_formIds'] = this.selectedTitleDocs[this.isEditedDocKey]['attachment_formIds'] || []
            docDetails['attachment_pages'] = this.selectedTitleDocs[this.isEditedDocKey]['attachment_pages'] || []
            docDetails['uuid'] = originalUuid

            this.selectedTitleDocs[this.isEditedDocKey] = {}
            this.selectedTitleDocs[this.isEditedDocKey] = docDetails
            this.selectedTitleDocs[this.isEditedDocKey]['template_doc'] = docDetails['column'] && docDetails['column'].text !== 'Insurance cards'
              ? (this.formType === 'cover_page' ? {text: 'Cover Page', value: true} : this.formType === 'attachments' ? {text: 'Attachments', value: true} : docDetails['template_doc'][0]) : docDetails['column']
          } else {
            this.selectedTitleDocs[this.columnCount] = {}
            this.selectedTitleDocs[this.columnCount] = docDetails
            this.selectedTitleDocs[this.columnCount]['template_doc'] = docDetails['column'] && docDetails['column'].text !== 'Insurance cards'
              ? (this.formType === 'cover_page' ? {text: 'Cover Page', value: true} : this.formType === 'attachments' ? {text: 'Attachments', value: true} : docDetails['template_doc'][0]) : docDetails['column']
            this.columnCount = this.columnCount + 1
          }
        } else {
          this.scene.children.map(column => {
            if (column.type === 'container') {
              this.extractFormTypeData(column.name, column.children)
              column.children.map(element => {
                if (checkedIdArray.indexOf(element.id) >= 0 && element.data.form) {
                  element.data.form.process = false
                  element.data.form.isEdited = false
                }
              })
            }
          })
        }
        if (this.isEditedDoc && isValidTemplates) {
          let originalFormIDs = this.editedCheckedBoxes || []
          let newFormIDs = docDetails['formIDs'] || []
          let removedFormIDs = originalFormIDs.filter((formID) => !newFormIDs.includes(formID))

          console.log('Edit save - Original form IDs:', originalFormIDs)
          console.log('Edit save - New form IDs:', newFormIDs)
          console.log('Edit save - Removed form IDs:', removedFormIDs)

          this.scene.children.map(column => {
            if (column.type === 'container') {
              this.extractFormTypeData(column.name, column.children)
              column.children.map(element => {
                if (element.data.form && removedFormIDs.includes(element.data.form.id)) {
                  element.data.form.process = false
                  element.data.form.isEdited = false
                  element.data.form.title = ''
                  element.data.form.template_doc_id = null
                  element.data.form.uuid = null
                }
              })
            }
          })
        }
        this.scene.children.map(column => {
          if (column.type === 'container') {
            this.extractFormTypeData(column.name, column.children)
            column.children.map(element => {
              if (checkedIdArray.indexOf(element.id) >= 0) {
                if (this.text !== '') {
                  element.data.form.title = this.text
                  element.data.form.process = true
                  element.data.form.product = this.selectedProduct
                }
              }
            })
          }
        })
        this.validAllForms()
        this.CheckboxClear()
        this.anyCheckboxSelected = false
        this.saveSelectedDocs()
      }
    },
    handleTemplateSelect: function () {
      let templateDoc = this.templateOptions.filter(templateDoc => templateDoc.value === this.forced_template_doc_id)
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + templateDoc[0].image_url
    },
    rotateSelectedImgs (angle) {
      let checkedIdArray = []
      let checkedFormIds = []
      let origPageNos = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      if (checkedIdArray.length === 0) {
        this.$refs.rotatePagesAlert.show()
      }
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(ele => {
            if (ele.data.form && checkedIdArray.includes(ele.id)) {
              checkedFormIds.push(ele.data.form.id)
              origPageNos.push(ele.data.form.original_page_no)
            }
          })
        }
      })
      if (checkedIdArray.length > 0) {
        this.loading = true
        this.rotateAllAngle = angle
        Vue.axios.post('form_docs/rotate_all_images', { ids: checkedFormIds, rotation_angle: this.rotateAllAngle, original_page_nos: origPageNos, form_doc_id: `${this.$route.params.id}` }, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            if (res.data.error) {
              Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_SUCCESS'), { type: 'success' })
            }
            let imageData = res.data.image_data
            this.scene.children.map(column => {
              if (column.type === 'container') {
                column.children.map(element => {
                  if (element.data.form) {
                    imageData.map(data => {
                      if (data.form_id === element.data.form.id) {
                        element.data.form.rotation = data.rotation_angle
                        element.data.form.angle = data.rotation_angle
                        element.data.form.rotation_angle = data.rotation_angle
                      }
                    })
                  }
                })
              }
            })
            this.rotateAllAngle = 0
            this.CheckboxClear()
          })
          .catch(err => {
            Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' })
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    doProcess () {
      let res = {}
      this.processButtonDisabled = true
      this.scene.children.map(column => {
        console.log('this.scene.children', this.scene.children)
        if (column.type === 'container') {
          res[column.name.replace(/ /g, '_')] = this.extractFormTypeData(column.name, column.children)
        }
      })
      const isAllSplit = this.isAllFormSplited(res)
      if (res.Templates) {
        res.Templates.forEach(template => {
          template.form.title = this.formDocTitle
        })
      }
      if (!isAllSplit) {
        this.beginSplit(res)
      } else {
        this.processButtonDisabled = false
        this.$refs.splitDocAlert.show()
      }
    },
    isAllFormSplited (res) {
      const isFalse = (image) => image.form.process === false
      return res.Templates.some(isFalse)
    },
    beginSplit (res) {
      // Show initial processing toast
      Vue.toasted.show('Processing export, please wait...', { type: 'info', duration: 2000 })

      Vue.axios.post('form_docs/process_esf_doc', {res, triage_doc_id: this.$route.params.id, inbound_doc_case_id: this.inBoundDocumentCaseId}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          console.log('Split API Response:', res.data)
          this.processButtonDisabled = false
          if (res.data.status === 'success') {
            Vue.toasted.show(res.data.message || 'Successfully exported to Salesforce', { type: 'success', duration: 3000 })
            this.$router.push('/process/processed')
          } else if (res.data.status === 'failed') {
            Vue.toasted.show(res.data.message || 'Export failed', { icon: 'chain-broken', type: 'error', duration: 5000 })
            if (res.data.errors && res.data.errors.length > 0) {
              console.error('Export errors:', res.data.errors)
            }
          } else {
            Vue.toasted.show(res.data.message || 'Unexpected response from server', { icon: 'chain-broken', type: 'error', duration: 5000 })
          }
        })
        .catch(err => {
          this.processButtonDisabled = false
          console.error('Split API Error:', err)
          let errorMessage = 'Export failed. Please try again.'
          if (err.response && err.response.data && err.response.data.message) {
            errorMessage = err.response.data.message
          } else if (err.message) {
            errorMessage = err.message
          }
          Vue.toasted.show(errorMessage, { icon: 'chain-broken', type: 'error', duration: 5000 })
        })
    },
    updateDisableCheckBox () {
      let checkedIdArray = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      this.anyCheckboxSelected = checkedIdArray.length > 0
      if (checkedIdArray.length > 0) {
        this.disableSaveButton = false
      } else if (this.$v.text.$error === true || (checkedIdArray.length === 0 && !this.selectAllThumbnails) || this.formType === null || (this.patientId === null && !this.hcoCaseNo && !this.physcianCaseNo)) {
        this.disableSaveButton = true
      } else {
        this.disableSaveButton = true
      }

      let templateColumnIds = []
      this.scene.children.map(column => {
        if (column.type === 'container' && column.name === 'Templates') {
          column.children.map(element => {
            if (element.data.form) {
              templateColumnIds.push(element.id)
            }
          })
        }
      })
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      if (checkedIdArray.length === 0) {
        this.selectAllTemplates = false
        this.selectAllThumbnails = false
      } else {
        let selectedTemplateIds = templateColumnIds.filter(element => checkedIdArray.includes(element))
        if (templateColumnIds.length === selectedTemplateIds.length && templateColumnIds.length > 0) {
          this.selectAllTemplates = true
        } else {
          this.selectAllTemplates = false
        }
        const allRefCheckboxes = this.$refs.CheckboxClicks
        const allRefCheckboxesChecked = allRefCheckboxes.length > 0 && allRefCheckboxes.every(cb => cb.checked)
        this.selectAllThumbnails = allRefCheckboxesChecked
      }
      if (templateColumnIds.length === 0) {
        this.selectAllTemplates = false
      }
      if (checkedIdArray.length === 0 && this.editedCheckedBoxes.length === 0) {
        if (!this.userManuallySelectedFormType) {
          this.formType = null
        }
      }
    },
    editPages (patientDetails, key) {
      this.editedCheckedBoxes = []
      this.isFirstEditButtonClicked = true
      this.scene.children.map(column => {
        if (column.type === 'container') {
          this.extractFormTypeData(column.name, column.children)
          column.children.map(element => {
            if (element.data.form && patientDetails.formIDs.includes(element.data.form.id)) {
              element.data.form.isEdited = true
              this.editedCheckedBoxes.push(element.data.form.id)
            } else if (element.data.form) {
              element.data.form.isEdited = false
            }
          })
        }
      })
      Object.keys(this.selectedTitleDocs).map(docTitle => {
        this.selectedTitleDocs[docTitle]['isEdited'] = false
      })
      this.selectedTitleDocs[key]['isEdited'] = true
      this.text = patientDetails['title']
      this.isEditedDoc = true
      this.disableSaveButton = false
      this.isEditedDocKey = key
      this.formType = patientDetails['formType']
      this.isPatientIdSelected = Boolean(patientDetails['patient_id'])
      this.selectedForceTemplate = patientDetails['force_template_id']
      this.sortEditedForms()
    }
  }
}
</script>

<style lang="scss" scoped>

.esf-main-container{
  font-family: 'WorkSans-regular';
}

.container-fluid {
  width: 500px
}
 .card-body, .card-block {
  padding: 1px;
}
.card {
  margin-bottom: 0px;
}
.scroll-image {
  height: 75vh;
  overflow-y:auto
}

label {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0rem;
  text-transform: capitalize;
  font-weight: bold;
}

.result {
  border: 1px solid rgb(241, 234, 234);
  border-collapse: collapse;
  text-align: center;
  padding: 5px;
  width: 100%;
  border: 1px solid #dee2e6;
}
.checkbox-padding {
  padding-left: 5px;
}

.notes-margin {
  margin-top: 20px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 9999; 
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  border: 6px solid #f3f3f3; 
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.thumbnail-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 2px solid gray;
  border-radius: 50%;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  margin-top: 0;
}

.thumbnail-checkbox:checked {
  background-color: #015BAC;
  border-color: #015BAC;
}
.thumbnail-checkbox:checked::after {
  content: '';
  position: absolute;
  top: 0px;
  left: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.select-input-container {
  position: relative;
  width: 350px;
  padding-top: 15px;
}

.select-input-container .custom-b-form-select {
  width: 100%;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.select-input-container label {
  position: absolute;
  top: 5px;
  left: 5px;
  background: white;
  color: #333;
  font-size: 12px;
  padding: 0 5px;
  z-index: 2;
}

h5 {
  margin-top: 10px;
  text-align: center;
}
/deep/ .modal-content {
  border-radius: 20px !important;
  overflow: hidden;
}
.custom-btn {
  background-color: white;
  color: black;
  border: 1px solid black;
  border-radius: 10px;
  padding: 6px 12px;
  transition: background-color 0.3s ease;
}

.custom-btn:hover {
  background-color: #34528d;
  color: white;
}

.table-con {
  height: 20vh;
  border-radius: 8px;
  border: none;
  padding: 0;
  overflow-y: auto;
}

.table-padding{
  padding: 4px 8px;
}

.table-left-align{
 text-align: left;
}

.table-right-align{
 text-align: right;
}

.table-center-align{
  text-align: center;
}

.black-border-btm{
  border-bottom: 1px solid #dee2e6;
}
.warning-bg-con-color{
  background-color: #fdf8e1;
}

.reject-bg-con-color{
  background-color: #f7cad0;
}

.warning-con {
  padding: 0.7rem;
  margin: -1rem;
}

/deep/ .modal-dialog {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto !important;
}

/deep/ .modal-content {
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.scrollable-content {
  max-height: 120vh;
  overflow-x: auto;
}

.esf-table-header-con{
  background-color: #EAECF0;
  font-size: 12px;
}

.action-btn-con{
  border-radius: 5px;
  padding: 0px 3px 0px 3px;
  border:none;
  background-color: white;
}

.process-btn-container{
  border-radius: 5px;
  height: 30px;
  width: fit-content;
  min-width: 100px;
}

.button-column {
  margin-top: 10px;
  align-items: center;
  gap: 15px;
  border-right: 2px solid #eee;
}

.table-column {
  padding-left: 20px;
}

.fill-color-btn-color{
  background-color:#015CAC;
  border: none;
  color: white;
}

.disabled-btn {
  background-color: gray;
  border: none;
  color: white;
}

.outline-btn-color{
  background-color:white;
  color: #015CAC;
  border: #015BAC 1px solid;
}

.light-blue-btn {
  background-color: #A3C1DA;
  border: none;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/forms/ESFTriagingProcessedForm.vue